import React, { useContext, useState } from 'react'
import ContentHeader from '@Components/ContentHeader'
import './index.scss'
import CatalogTransferWelcome from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWelcome'
import CatalogTransferTypeSelection from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferTypeSelection'
import CatalogTransferButtonContainer from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferButtonContainer'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'
import Navigation from '@App/navigation'

const CatalogTransfer = () => {
    const { catalogTransferWizardStore, rightsholderStore, preloaderStore } = useContext(StoresContext)
    const navigate = useNavigate()
    const [step, setStep] = useState<'welcome' | 'type'>('welcome')

    const createAndRedirect = async (type: 'acquiring' | 'relinquishing') => {
        preloaderStore.openTransparentPreloader(true)
        await catalogTransferWizardStore.createCatalogTransfer(type === 'acquiring' ? 'ACQUISITION' : 'RELINQUISHMENT')
        navigate(
            Navigation.rightholder.catalogTransfer.wizard(
                rightsholderStore.currentRightsholderId,
                catalogTransferWizardStore.currentTransferId
            )
        )
        preloaderStore.openTransparentPreloader(false)
    }

    return (
        <div>
            <ContentHeader title="Catalog Transfer Tool" />
            <div className="catalog-transfer-wrapper">
                {step === 'welcome' && <CatalogTransferWelcome />}
                {step === 'type' && <CatalogTransferTypeSelection onClick={createAndRedirect} />}
                {(step === 'welcome' || step === 'type') && (
                    <CatalogTransferButtonContainer step={step} setStep={setStep} />
                )}
            </div>
        </div>
    )
}

export default CatalogTransfer
